import { Observation, SpeciesGroupId } from '@/api/rest/resources/conservation';

import { useConservation, useConservationFile } from './useConservation';
import { useConservationProjectName } from './useConservationProjectName';
import { useProject } from './useProject';

export const useObservation = (id?: string): Observation[] => {
  const projectName = useConservationProjectName(id);

  if (!projectName) {
    throw new Error('Conservation project name not found');
  }

  const observations =
    useConservationFile<Observation[]>({
      projectName,
      fileName: 'observation.json',
    }) ?? [];

  return observations.map((o, index) => ({ ...o, id: (o.key || index + 1)?.toString() }));
};

export const useAllGroupObservations = (id?: string): Record<SpeciesGroupId, Observation[]> => {
  const project = useProject(id);
  const projectName = useConservationProjectName(id);

  if (!projectName) {
    throw new Error('Conservation project name not found');
  }

  const { data } = useConservation(projectName);
  const speciesGroupIds = Object.keys(project?.speciesGroups ?? {}) as SpeciesGroupId[];

  const groupObservations: Record<SpeciesGroupId, Observation[]> = {} as Record<SpeciesGroupId, Observation[]>;

  speciesGroupIds.forEach((group) => {
    const fileName = `${group}_observation.json` as keyof typeof data;
    const observations = (data?.[`${fileName}`] as Observation[]) ?? [];
    groupObservations[`${group}`] = observations.map((o, index) => ({ ...o, id: (o.key || index + 1)?.toString() }));
  });

  return groupObservations;
};
